import AdbInput from './src/adb-input.vue';

AdbInput.install = function (Vue) {
  Vue.component(AdbInput.name, AdbInput);
};

export default AdbInput;
